import whatsappUtilsApi from './createApi/whatsappUtils';

export const whatsappUtils = {
	getNegotiationDashboard: async ( payload ) => {
		return await whatsappUtilsApi.post( '/dashboard/negotiation', payload );
	}
};